// extracted by mini-css-extract-plugin
module.exports = {"label":"ChangeSignature_label__3lY79"};